import React, {useState} from 'react'
import Button from '@components/Button'
import Checkbox from '@components/fields/Checkbox'
import Link from 'next/link'
import {Field, Form} from 'simple-react-form'

import styles from './styles.module.css'

function BodyCookie() {
  return (
    <div className={styles.message}>
      El presente sitio web de Get Justo S.A.C. utiliza una cookie de marketing que nos permite
      analizar los posibles intereses y/o necesidades de los usuarios que aceptan su activación, con
      el propósito de que a dichos usuarios se les pueda remitir anuncios publicitarios que se
      ajusten a su perfil individual. Lo anterior, de conformidad con lo establecido en la{' '}
      <Link href={`/documentos-legales/cookies`}>
        <u className={styles.url}>Política de Cookies</u>
      </Link>
      , documento que es supletoriamente aplicable al presente consentimiento.
    </div>
  )
}

interface IDetailsCookie {
  cookiesSelected: object
  selectCookies: any
}

export interface IPeruSelectCookies extends IDetailsCookie {
  handleButton(accepted: boolean): void
}

function DetailsCookie(props: IDetailsCookie) {
  const {cookiesSelected, selectCookies} = props
  return (
    <div className={styles.message}>
      <Form state={cookiesSelected} onChange={selectCookies}>
        <div className={styles.message}>
          <Field
            fieldName="necessaryCookie"
            type={Checkbox}
            label={'Necesarias'}
            value={true}
            disabled={true}
          />
          Las cookies necesarias nos ayudan a hacer utilizable el Sitio Web, toda vez que nos
          permiten activar sus funciones básicas (como, por ejemplo, la navegación dentro del Sitio
          Web). El Sitio Web no puede funcionar adecuadamente sin estas cookies.
        </div>

        <div className={styles.message}>
          <Field fieldName="statisticsCookie" type={Checkbox} label={'Estadística'} />
          Las cookies estadísticas nos ayudan a comprender cómo interactúan los usuarios con el
          Sitio Web. Para ello, estas cookies recopilan, administran y procesan información
          anonimizada sobre las acciones de los usuarios en el Sitio Web.
        </div>
        <div className={styles.message}>
          <Field fieldName="marketingCookie" type={Checkbox} label={'De Marketing'} />
          Las cookies de marketing se utilizan para analizar posibles intereses y/o necesidades de
          los usuarios del Sitio Web. Lo anterior, con el propósito de mostrarles anuncios
          publicitarios de conformidad con su perfil individual.
        </div>
      </Form>
    </div>
  )
}

function PeruSelectCookies(props: IPeruSelectCookies) {
  const {cookiesSelected, selectCookies, handleButton} = props
  const [showDetails, setShowDetails] = useState(false)

  const toggleShowDetails = () => {
    setShowDetails(!showDetails)
  }

  const showTextAccept = () => {
    return showDetails ? 'Acepto' : 'Acepto todas las cookies'
  }

  return (
    <div>
      {showDetails ? (
        <DetailsCookie cookiesSelected={cookiesSelected} selectCookies={selectCookies} />
      ) : (
        <BodyCookie />
      )}

      <div className={styles.cookiesRow}></div>
      <div className={styles.cookieButtonsRow}>
        {showDetails ? null : <Button onClick={toggleShowDetails}>Configuración de Cookies</Button>}

        <div className={styles.buttonSpacer}></div>
        <Button primary onClick={handleButton}>
          {showTextAccept()}
        </Button>
      </div>
    </div>
  )
}

export default PeruSelectCookies
